import type { ComponentProps } from "react";

import { cn, Field, Slider as DSSlider, type FieldClassNames } from "@eisox/design-system";

import { useFieldContext } from "../form.context";
import { FieldErrors } from "./field-errors.component";

interface SliderProps extends ComponentProps<typeof DSSlider> {
  classNames?: FieldClassNames & ComponentProps<typeof DSSlider>["classNames"];
}

const Slider: React.FC<SliderProps> = ({ onValueChange, onBlur, className, classNames, ...props }) => {
  const field = useFieldContext<number | undefined>();
  const { root, control, error, ...sliderClassNames } = classNames ?? {};

  return (
    <Field.Root className={root}>
      <DSSlider
        {...props}
        // Field.Root aligns its children to the start: without w-full the slider shrinks to its label's width
        className={cn("w-full", className, control)}
        classNames={sliderClassNames}
        value={field.state.value}
        onValueChange={value => {
          field.handleChange(value);
          onValueChange?.(value);
        }}
        onBlur={event => {
          field.handleBlur();
          onBlur?.(event);
        }}
      />
      <FieldErrors className={error} />
    </Field.Root>
  );
};

export { Slider };
export type { SliderProps };
